import { HttpErrorResponse } from '@angular/common/http';
import { LoggedInUserDto } from 'src/app/core/interfaces/loggedInUserDto';
import { UserAnnouncementRequest } from './../../../core/classes/userAnnouncementRequest';
import { Component, OnInit, Inject, ViewChild, SecurityContext } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AnnouncementModalService } from 'src/app/core/services/announcement-modal/announcement-modal.service';
import { DomSanitizer } from '@angular/platform-browser';
import { isNullOrUndefined } from 'util';
import { Observable } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Constants } from '../../constants';
import { map } from 'rxjs/operators';
import { SlickCarouselComponent } from 'ngx-slick-carousel';

@Component({
    selector: 'app-annouce-banner',
    templateUrl: './annouce-banner.component.html',
    styleUrls: ['./annouce-banner.component.scss'],
    standalone: false
})
export class AnnouceBannerComponent implements OnInit {
  @ViewChild('slickModal') slickModal: SlickCarouselComponent;
   slickConfig = {
    breakpoint: 1024,
    slides: 5,
    infinite: false,
    speed: 250,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: false,
    dots: true,
    dotsClass: 'slick-dots',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  content: any;
  slidesContainer: Array<{title: string, publishFromDate: Date, publishToDate: Date, htmlContent: any}> = [];
  slidesCount = 0;
  updaterequestObject: UserAnnouncementRequest = new UserAnnouncementRequest();
  isScreenSmall: Observable<boolean>;

  constructor(public dialogRef: MatDialogRef<AnnouceBannerComponent>,
              private annonceService: AnnouncementModalService, private sanitized: DomSanitizer,
              @Inject(MAT_DIALOG_DATA) public data: any, breakpoints: BreakpointObserver) {
                this.isScreenSmall = breakpoints.observe(`(max-width: ${Constants.MEDIUM_WIDTH_BREAKPOINT}px)`)
      .pipe(map(breakpoint => breakpoint.matches));

               }

  ngOnInit() {
    this.slidesContainer = this.data.data;
    if (this.data.type === 'BANNER') {
      this.slidesContainer.forEach((data: any) => {
        data.htmlContent = this.sanitized.sanitize(SecurityContext.HTML, data.htmlContent) ?? '';
      });
    } else {
      this.content = this.slidesContainer[this.slidesCount];
      this.content.htmlContent = this.sanitized.sanitize(SecurityContext.HTML, this.content.htmlContent) ?? '';
    }
  }

  CloseDialog() {
    const self = this;
    self.dialogRef.close(false);
  }

  loadNext() {
    if (this.content.displayOnceUponLogon && !isNullOrUndefined(this.content.userId)) {
      this.updaterequestObject.userId = this.content.userId;
      this.updaterequestObject.announcementId = this.content.announcementId;
      this.updateUserAnnouncements(this.updaterequestObject);
    }
    this.increaseSlide();

    }

increaseSlide() {
  this.slidesCount++;
  if (this.slidesCount === this.slidesContainer.length) {
    this.dismiss();
  } else {
    this.content = this.slidesContainer[this.slidesCount];
  }
}
  updateUserAnnouncements(updateRequestObject: UserAnnouncementRequest) {
     this.annonceService.updateUserAnnouncement(updateRequestObject).subscribe({
      next: (res: { IsSuccess: string , Message: string }) => {
      },
      error: (error: HttpErrorResponse) => {
      }
      });
  }

  dismiss() {
    this.dialogRef.close(false);
  }

}
